import { get, post } from "../utils/request";

/**
 * 获取庭院案例数据
 * @param {*} vm
 * @param {*} cb
 */
export const caseInfo = (vm, cb) => {
  post("/api/yardsample/searchById")
    .then(res => {
      //console.log(res);
      if (res.code == 200) {
        vm.info = res.data.content;
        if (cb !== undefined) {
          cb();
        }
      }
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};
